<template>
  <div class="loginForm">
		<v-card
      class="mx-auto"
      max-width="95%"
    >
			<v-list-item-title class="headline mb-1">
				Sign In
				<h1 class="d-sr-only">Researcher Site Sign In</h1>
			</v-list-item-title>
			<v-divider></v-divider>
			<div v-if="displayLoginForm">
				<v-form
					ref="form"
					align="center"
					v-model="valid"
				>
					<v-text-field
						v-model="username"
						label="Username"
						:rules="[v => !!v || 'Username is required']"
						required
					></v-text-field>
					<v-text-field
						v-model="password"
						label="Password"
						type="password"
						:rules="[v => !!v || 'Password is required']"
						required
						@keydown.enter="devLogin"
					></v-text-field>
					<v-btn
					class="btn-default"
					text
          :disabled="!valid"
					:loading="loginBtnLoading"
          @click="devLogin"
					>
						Login
					</v-btn>
				</v-form>
				<p class="p2 login-error" v-if="loginError">Login failed. Please try again.</p>
			</div>
			<div v-else>
				<v-btn class="btn-default" text @click="login">Sign In</v-btn>
			</div>
		</v-card>
		<v-card v-if="displayRegister" class="mx-auto" max-width="95%">
			<v-list-item-title class="headline mb-1">Register</v-list-item-title>
			<p v-if="registerHostingMessage">
				ASA24 is currently hosted in the cloud at this url: <a href="https://asa24.nih.gov/researcher">https://asa24.nih.gov/researcher</a>. Use the register button below to register an account at that url.
			</p>
			<v-btn
				class="btn-default"
				text
				@click="goToRegister"
			>
				Register
			</v-btn>
		</v-card>
  </div>
</template>

<script>
import { utilityService } from '@/services/utilityService.js';
import { authService } from '@/services/authService.js';
import { authTokenService } from '@/services/authTokenService.js';
export default {
	name: 'LoginForm',
	data: () => ({
		env: null,
		displayLoginForm: null,
		username: null,
		password: null,
		valid: true,
		loginUrl: null,
		loginBtnLoading: false,
		loginError: false,
		displayRegister: null,
		registerUrl: null,
		registerHostingMessage: false
	}),
	props: {
	},
	mounted () {
		this.env = utilityService.getEnv();
		this.loginUrl = utilityService.getLoginUrl();
		this.displayLoginForm = utilityService.getDisplayLoginForm();
		this.displayRegister = utilityService.getDisplayRegister();
		this.registerUrl = utilityService.getRegisterUrl();
		this.registerHostingMessage = utilityService.getRegisterHostingMessage();
		authTokenService.clearSession();
	},
	computed: {
		displayRegisterButton () {
			return utilityService.getDisplayRegisterButton();
		}
	},
	methods: {
		async devLogin () {
			this.loginBtnLoading = true;
			const me = this;
			authService.login(this.username, this.password)
				.then(function () {
					if (authTokenService.getToken() != null) {
						me.loginError = false;
						me.$store.dispatch('loginStartup').then(function () {
							me.loginBtnLoading = false;
							me.$router.push('/landing');
						});
					}
				})
				.catch(function (e) {
					me.loginError = true;
					me.loginBtnLoading = false;
					if (e.message.includes('401')) {
						console.log('Username or password is incorrect');
					} else if (e.message.includes('500')) {
						console.log('Server problem');
					}
				});
		},
		login () {
			location.replace(this.loginUrl);
		},
		goToRegister () {
			if (this.registerUrl) {
				location.replace(this.registerUrl);
			} else {
				this.$router.push('/register');
			}
		}

	}
}
</script>

<style>
.v-text-field, .v-btn {
	margin: 10px;
}
</style>
